<template> <div></div> </template>

<script>
import { firestore } from "@/services/firebase";

const notificationsRef = firestore.collection("notifications");

export default {
  name: "PersonalNotification",

  props: ["username"],

  data() {
    return {
      notifications: [],
    };
  },

  watch: {
    notifications: function() {
      if (!this.notifications || !this.notifications.length) return;
      const notification = this.notifications.filter(
        (n) =>
          !n.isHidden &&
          n.fromDate.toDate() < new Date() &&
          (!n.toDate || n.toDate.toDate() > new Date()) &&
          (n.type === "Blocking" || !n.seen || !n.seen.includes(this.username))
      )[0];
      if (!notification) return;
      this.$buefy.dialog.confirm({
        title: notification.type === "Blocking" ? "Alert" : "Notification",
        message: notification.text,
        type: notification.type === "Blocking" ? "is-danger" : "is-info",
        hasIcon: true,
        canCancel: notification.type !== "Blocking",
        closeOnConfirm: notification.type !== "Blocking",
        onConfirm: () => this.handleConfirm(notification),
      });
    },
  },

  methods: {
    handleConfirm(notification) {
      if (notification.url) {
        this.$router.push(notification.url);
        return;
      }

      if (notification.type === "Blocking") {
        window.location = "https://www.chesssquad.com/logout.php";
        return;
      }
      notificationsRef.doc(notification.id).update({
        seen: notification.seen
          ? [...notification.seen, this.username]
          : [this.username],
      });
    },
  },

  created() {
    this.$bind(
      "notifications",
      notificationsRef.where("usernames", "array-contains", this.username)
    );
  },
};
</script>

<style></style>
